<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="pill py-4 mt-4">
          <div class="pill__item mb-3">
            <div class="pill__inner">
              <div class="me-4 pill__icon-container">
                <img width="25" height="12.5" src="/images/unlimited-icon.webp" alt="Unlimited data icon" class="pill__icon" loading="lazy"  />
              </div>
              <div class="pill__text">Uncapped calls and texts</div>
            </div>
          </div>
          <div class="pill__item mb-3">
            <div class="pill__inner">
              <div class="me-4 pill__icon-container">
                <img width="25" height="37" src="/images/fiveg-icon.webp" alt="Unlimited data icon" class="pill__icon" loading="lazy"  />
              </div>
              <div class="pill__text">Fast 5G as standard</div>
            </div>
          </div>
          <div class="pill__item mb-3">
            <div class="pill__inner">
              <div class="me-4 pill__icon-container">
                <img width="25" height="15" src="/images/roaming-icon.webp" alt="Unlimited data icon" class="pill__icon" loading="lazy"  />
              </div>
              <div class="pill__text">Roam free in 75 destinations worldwide</div>
            </div>
          </div>
          <div class="pill__item mb-3">
            <div class="pill__inner">
              <div class="me-4 pill__icon-container">
                <img width="25" height="25" src="/images/free-delivery-icon.webp" alt="Unlimited data icon" class="pill__icon" loading="lazy"  />
              </div>
              <div class="pill__text">Free delivery</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.pill {
  display: flex;
  flex-wrap: wrap;
  filter: drop-shadow(var(--box-shadow));

  &__item {
    width: 100%;
    @media only screen and (min-width: 450px) {
      width: 50%;
    }
    @media only screen and (min-width: 1200px) {
      width: 25%;
    }
  }

  &__inner {
    padding: 1em 2em;
    margin: 0 0.5em;
    background: var(--black);
    border-radius: 50px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: var(--primary);
    min-height: 80px;
  }
  &__icon-container {
    width: 10%;
  }
  &__icon {
    width: 25px;
    height: auto;
    @media only screen and (min-width: 700px) {
      width: 28px;
    }
  }
  &__text {
    font-size: 1em;
  }
}
</style>
